module.exports = __webpack_public_path__ + "static/upload-badge-image-in-image-manager-2591a9831336ccd2db650dff01d402fe.jpg";